import React from "react";
import styled from "styled-components";

const SkeletonWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 25px;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const SkeletonCard = styled.div`
  background: #f0f0f0;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const SkeletonImage = styled.div`
  width: 100%;
  height: 250px;
  background: linear-gradient(90deg, #f0f0f0 0%, #e0e0e0 50%, #f0f0f0 100%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

const SkeletonInfo = styled.div`
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
`;

const SkeletonLine = styled.div`
  height: ${(props) => props.$height || "12px"};
  background: linear-gradient(90deg, #e0e0e0 0%, #d0d0d0 50%, #e0e0e0 100%);
  background-size: 200% 100%;
  border-radius: 4px;
  animation: shimmer 1.5s infinite;
  width: ${(props) => props.$width || "100%"};

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

const SkeletonActions = styled.div`
  display: flex;
  gap: 10px;
  margin-top: auto;
  padding-top: 10px;
  border-top: 1px solid #e8e8e8;
`;

const SkeletonButton = styled.div`
  flex: 1;
  height: 38px;
  background: linear-gradient(90deg, #e0e0e0 0%, #d0d0d0 50%, #e0e0e0 100%);
  background-size: 200% 100%;
  border-radius: 4px;
  animation: shimmer 1.5s infinite;

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

const WishlistSkeleton = ({ count = 6 }) => {
  return (
    <SkeletonWrapper>
      {[...Array(count)].map((_, i) => (
        <SkeletonCard key={i}>
          <SkeletonImage />
          <SkeletonInfo>
            <SkeletonLine $height="16px" $width="100%" />
            <SkeletonLine $height="12px" $width="60%" />
            <SkeletonLine
              $height="14px"
              $width="40%"
              style={{ marginTop: "8px" }}
            />
            <SkeletonLine $height="12px" $width="70%" />
            <div
              style={{
                marginTop: "auto",
                paddingTop: "10px",
                borderTop: "1px solid #e8e8e8",
              }}
            >
              <SkeletonActions>
                <SkeletonButton />
                <SkeletonButton />
              </SkeletonActions>
            </div>
          </SkeletonInfo>
        </SkeletonCard>
      ))}
    </SkeletonWrapper>
  );
};

export default WishlistSkeleton;
